import React from 'react';
import { Config } from '@leverege/plugin';
import { Pane, Text } from '@leverege/ui-elements';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_MESSAGE = 'Your Network connection has been lost.';
const DEFAULT_ICON = 'fa fa-exclamation-triangle';

/**
 * Returns a loading view.
 */
export default class NetworkOffline extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      online: navigator.onLine
    };
  }
  componentDidMount() {
    window.addEventListener('online', this.onOnlineChange);
    window.addEventListener('offline', this.onOnlineChange);
  }
  componentWillUnmount() {
    window.removeEventListener('online', this.onOnlineChange);
    window.removeEventListener('offline', this.onOnlineChange);
  }
  onOnlineChange = () => {
    this.setState({
      online: navigator.onLine
    });
  };
  render() {
    const {
      online
    } = this.state;
    if (online) {
      return null;
    }
    const {
      variant = 'networkOffline|warning',
      message,
      icon
    } = this.props;
    const msg = message === undefined ? Config.get('NetworkOffline', 'message', DEFAULT_MESSAGE) : message;
    const icn = icon === undefined ? Config.get('NetworkOffline', 'icon', DEFAULT_ICON) : icon;
    return /*#__PURE__*/_jsx(Pane, {
      variant: "networkOffline",
      children: /*#__PURE__*/_jsx(Text, {
        icon: icn,
        variant: variant,
        children: msg
      })
    });
  }
}